import Button from "./Button.vue";
import DropdownButton from "./DropdownButton.vue";

export { Button as CustomButton, DropdownButton };


// WEBPACK FOOTER //
// ./src/components/Button/index.js